<template>
  <v-main class="mt-1">
    <v-row class="text-left mt-4 mb-0" v-if="!$vuetify.display.mobile">
      <v-col cols="12">
        DASHBOARD KOORDYNATORA
      </v-col>
    </v-row>
  </v-main>
</template>

<script>

export default {
  name: 'dashboard-coordinator-view'
}

</script>

<style lang="scss" scoped>

.v-row {
  margin: 0;
  padding: 0;
}

.crumb {
  text-align: left;
  @include nsb-font-header;
  font-size: 10px;
  line-height: 15px;
  color: $nsb-disabled-text;
  .current {
    @include nsb-font-header-bold;
    font-size: 10px;
    line-height: 15px;
    color: $ds-primary;
  };
}
</style>